module.exports = __webpack_public_path__ + "static/img/bg-vip3.1765e2d7.png";